import { EditLodgingRequestState, EditLodgingRequestActionTypes, EDIT_LODGING_REQUEST_DATA_REQUEST, EDIT_LODGING_REQUEST_DATA_SUCCESS, EDIT_LODGING_REQUEST_DATA_FAILURE } from "store/reducers/lodgingRequest/edit/types";

const defaultState: EditLodgingRequestState = {
  isLoading: false,
  errorMessage: ""
};

export default function editLodgingRequest(state = defaultState, action: EditLodgingRequestActionTypes): EditLodgingRequestState {
  switch (action.type) {
    case EDIT_LODGING_REQUEST_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case EDIT_LODGING_REQUEST_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case EDIT_LODGING_REQUEST_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};